var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ButtonBasic from "@rentiohq/shared-frontend/dist/components/components/ButtonBasic";
import Spacer, { ESpacerWeight, } from "@rentiohq/shared-frontend/dist/components/components/Spacer";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import { MultiStepForm } from "../../../../components/SharedForm/MultiStepForm";
import { FieldsContext } from "../Editor/contexts/Fields.context";
import { DEFAULT_VARIABLES } from "../Editor/Editor.config";
import InsertVariableModal from "../InsertVariableModal";
import { insertCondition } from "./InsertConditionModal.utils";
import schemas from "./schemas";
import { EField } from "./schemas/schema.insertCondition.types";
var InsertModal = function (props) {
    var editorState = props.editorState, setEditorState = props.setEditorState, onClose = props.onClose;
    // Context
    var _a = React.useContext(FieldsContext), fields = _a.fields, setFields = _a.setFields;
    // State
    var formId = React.useState(generateFormId())[0];
    var _b = React.useState(false), showInsertVariableModal = _b[0], setShowInsertVariableModal = _b[1];
    // Helpers
    var getCleanFormData = function (formData) {
        var variableId = formData[EField.Name];
        var type = formData[EField.Type];
        var contentText = formData[EField.ContentText];
        var contentDate = formData[EField.ContentDate];
        var contentNumber = formData[EField.ContentNumber];
        return {
            variableId: variableId,
            type: type,
            contentText: contentText,
            contentNumber: contentNumber,
            contentDate: contentDate,
        };
    };
    var insertFields = function (formData) {
        var _a = getCleanFormData(formData), variableId = _a.variableId, newCondition = __rest(_a, ["variableId"]);
        var existingVariable = __spreadArray(__spreadArray([], fields.variables, true), DEFAULT_VARIABLES, true).find(function (x) { return x.id === variableId; });
        var condition = __assign({ id: "".concat(Math.random()), variableId: variableId }, newCondition);
        setFields({
            groupId: existingVariable === null || existingVariable === void 0 ? void 0 : existingVariable.groupId,
            variableId: variableId,
            condition: condition,
        });
        return condition;
    };
    // Event handlers
    var onSubmitInsert = function (formData) {
        var condition = insertFields(formData);
        setEditorState(insertCondition(editorState, condition));
        onClose();
    };
    // Render
    return (_jsxs(_Fragment, { children: [!showInsertVariableModal && (_jsx(MultiStepForm, { formId: "insert-loop-".concat(formId), schemas: schemas({ fields: fields }), asModal: true, withAside: false, modalProps: {
                    onClose: onClose,
                    heading: getLocalizedText("editor.insert_custom.insert_condition.modal.title"),
                    width: "medium",
                    children: (_jsxs(_Fragment, { children: [_jsx(ButtonBasic, { title: getLocalizedText("editor.insert_custom.insert_variable.modal.title"), onPress: function () {
                                    setShowInsertVariableModal(true);
                                } }), _jsx(Spacer, { weight: ESpacerWeight.W12 })] })),
                }, onSuccess: onSubmitInsert, submitLabel: getLocalizedText("system.insert") })), showInsertVariableModal && (_jsx(InsertVariableModal, { editorState: editorState, onClose: function () { return setShowInsertVariableModal(false); }, forceCreateNewVariable: true }))] }));
};
// eslint-disable-next-line import/no-default-export
export default InsertModal;
